<template>
  <div id="app">
    <div class="content-container">
      <div class="column cloud-datasets-content" role="main">
        <div class="data-list-container">
        <datatable-filters  @filter_text="setDatasetFilterText"  @switch="switchDatasetDisplayMode"></datatable-filters>
        <div class="table-scroll-wrapper">
          <dataset-list-placeholder v-if="!data_ready"></dataset-list-placeholder>
          <dataset-table v-if="display_mode == 'table' && data_ready" :filter_text="filter_text.dataset"></dataset-table>
          <!--<dataset-list v-if="display_mode == 'list' && data_ready" :filter_text="filter_text.dataset"></dataset-list>-->
          <dataset-list v-if="display_mode == 'list'" :filter_text="filter_text.dataset"></dataset-list>
          <datasets_modal v-show="modal.science_keyword_datasets.visible" @close_modal="close_modal"></datasets_modal>
          <service_tools_modal v-show="modal.tools_services.visible" @close_modal="close_modal"></service_tools_modal>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapState, mapMutations} from "vuex"
import DatatableFilters from "@/components/DatatableFilters"
import DatasetTable from "@/components/DatasetTable"
import DatasetList from "@/components/DatasetList"
import DatasetListPlaceholder from "@/components/DatasetListPlaceholder"
import datasets_modal from "@/components/datasets_modal";
import service_tools_modal from "@/components/service_tools_modal";

var Drupal = window.Drupal && window.Drupal.settings || {};
//var drupalSettings = window.drupalSettings;

export default {
  name: 'App',
  components: {
    DatatableFilters,
    DatasetTable,
    DatasetList,
    DatasetListPlaceholder,
    datasets_modal,
    service_tools_modal,
  },
  data() {
    return {
      'title': '',
      'filter_text': {
         'dataset': ''
      }
    }
  },
  computed: {
    ...mapState([
      'display_mode',
      'page_total',
      'page_size',
      'query_params',
      'cloud_datasets',
      'data_ready',
      'modal'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_DATA',
      'SET_DISPLAY_MODE',
      'SET_DATASETS',
      'SET_APPEND_DATASETS',
      'UPDATE_CAPABILITIES',
      'SET_UMM_S_DATA',
      'SET_DATA_READY',
      'SET_UMM_S_T_ITEMS',
      'SET_MODAL_VISIBILITY'
    ]),
    setDatasetFilterText: function(filter_value) {
        this.filter_text.dataset = filter_value;
    },
    switchDatasetDisplayMode: function(mode) {
      this.SET_DISPLAY_MODE(mode);
      this.$forceUpdate();
    },
    retrieve_paging_datasets(api, start_num) {
      //let api = 'https://cmr.earthdata.nasa.gov/search/collections.umm_json?provider=POCLOUD&tag_key=gov.nasa.eosdis';
      api += "?format=umm_json&provider=POCLOUD";
      const self = this;

      if(self.query_params.ids && Array.isArray(self.query_params.ids) && self.query_params.ids.length > 0) {
        api += "&ids=" + self.query_params.ids.join(":");
      }
      if(self.query_params.values && Array.isArray(self.query_params.values) && self.query_params.values.length > 0) {
        let valuesOfvalues = [];
        self.query_params.values.forEach(function(vals) {
          valuesOfvalues.push(vals.join(":"));
        })
        if(valuesOfvalues.length > 0) api += "&values=" + valuesOfvalues.join("::");
      }
      api += "&view=" + self.query_params.view;
      //api += "&" + self.query_params.join("&");


      for(let page_num = start_num; page_num <= self.page_total; page_num++) {
        Vue.axios.get(api + "&page_num=" + page_num + "&page_size=" + self.page_size).then(function(response) {
          // console.log(response.data);
          self.SET_APPEND_DATASETS(response.data.items);
          if(page_num == self.page_total) {
            self.SET_DATA_READY(true);
          }
        });
      }
    },
    retrieve_datasets(api, pages) {
      //console.log('running retrieve_datasets');
      api += "?format=umm_json&provider=POCLOUD";
      const self = this;

      if(self.query_params.ids && Array.isArray(self.query_params.ids) && self.query_params.ids.length > 0) {
        api += "&ids=" + self.query_params.ids.join(":");
      }
      if(self.query_params.values && Array.isArray(self.query_params.values) && self.query_params.values.length > 0) {
        let valuesOfvalues = [];
        self.query_params.values.forEach(function(vals) {
          valuesOfvalues.push(vals.join(":"));
        })
        if(valuesOfvalues.length > 0) api += "&values=" + valuesOfvalues.join("::");
      }
      api += "&view=" + self.query_params.view;

      let axios_requests = [];
      for(let page_num = 1; page_num <= pages; page_num++) {
        axios_requests.push(Vue.axios.get(api + "&page_num=" + page_num));
      }
      //console.log(axios_requests);
      Vue.axios.all(axios_requests).then(Vue.axios.spread((...responses) => {
        for(let rIndex = 0; rIndex < pages; rIndex++) {
          self.SET_APPEND_DATASETS(responses[rIndex].data.items);
          if(rIndex == (self.page_total - 1)) self.SET_DATA_READY(true);

          //console.log(responses[rIndex].data.items);
        }
      }));
    },
    query_pocloud_umms(umm_s_api) {
      const self = this;
      Vue.axios.get(umm_s_api + '.umm_json?provider=POCLOUD').then(function(response) {
        //console.log(response.data);
        self.SET_UMM_S_DATA(response.data);
      });
    },
    close_modal(modal_name) {
      this.SET_MODAL_VISIBILITY({'modal_name':modal_name, 'visibility':false});
    },
    load_capabilities_services_tools(capabilities_data, tools_services, umm_s_api, umm_t_api) {
      let umm_s_request = umm_s_api + '.umm_json?',umm_t_request = umm_t_api + '.umm_json?',conceptids = [];
      const self = this;
      tools_services['umm-s'].forEach(function(umms) {
          conceptids.push('concept-id=' + umms['concept-id']);
      });
      umm_s_request += conceptids.join('&');
      tools_services['umm-t'].forEach(function(ummt) {
        conceptids.push('concept-id=' + ummt['concept-id']);
      });
      umm_t_request += conceptids.join('&');
      // console.log(capabilities_data);
      // console.log(umm_s_request);
      // console.log(umm_t_request);
      const request_umms = Vue.axios.get(umm_s_request);
      const request_ummt = Vue.axios.get(umm_t_request);
      Vue.axios.all([request_umms, request_ummt]).then(Vue.axios.spread((...responses) => {
        const umms_response = responses[0];
        const ummt_response = responses[1];
        self.set_umms_capabilities(umms_response.data,ummt_response.data,tools_services,capabilities_data);
        /*
        self.SET_UMM_S_T_ITEMS({'umms':umms_response.data.items, 'ummt':ummt_response.data.items});
        for( let [key, capability_data] of Object.entries(capabilities_data)) {
          capability_data['tools_services'] = [];
          if(capability_data['MappedTerm'].length > 0) {
            umms_response.data.items.forEach(function(umms) {
              let found_keyword = Vue._.find(umms['umm']['ServiceKeywords'], function(keyword) {
                return capability_data['MappedTerm'].includes(keyword['ServiceTerm']);
              });
              if(found_keyword) {
                capability_data['tools_services'].push(Vue._.find(tools_services['umm-s'], function(item) {
                  return item['concept-id'] == umms['meta']['concept-id'];
                }));
              }
            });
            ummt_response.data.items.forEach(function(ummt) {
              //console.log(ummt);
              let found_keyword = Vue._.find(ummt['umm']['ToolKeywords'], function(keyword) {
                return capability_data['MappedTerm'].includes(keyword['ToolTerm']);
              });
              if(found_keyword) {
                capability_data['tools_services'].push(Vue._.find(tools_services['umm-t'], function(item) {
                  return item['concept-id'] == ummt['meta']['concept-id'];
                }));
              }
            });
          }
            capability_data['count'] = 0;
        }
        self.UPDATE_CAPABILITIES(capabilities_data);
        */
      })).catch(errors => {
        console.log(errors);
      })
    },
    set_umms_capabilities(umms_data, ummt_data, tools_services, capabilities_data) {
      this.SET_UMM_S_T_ITEMS({'umms':umms_data.items, 'ummt':ummt_data.items});
      for( let [key, capability_data] of Object.entries(capabilities_data)) {
        capability_data['tools_services'] = [];
        if(capability_data['MappedTerm'].length > 0) {                    
          umms_data.items.forEach(function(umms) {
            let found_keyword = Vue._.find(umms['umm']['ServiceKeywords'], function(keyword) {
              return capability_data['MappedTerm'].includes(keyword['ServiceTerm']);
            });
            if(found_keyword) {
              capability_data['tools_services'].push(Vue._.find(tools_services['umm-s'], function(item) {
                return item['concept-id'] == umms['meta']['concept-id'];
              }));
            }
          });
          ummt_data.items.forEach(function(ummt) {
            //console.log(ummt);
            let found_keyword = Vue._.find(ummt['umm']['ToolKeywords'], function(keyword) {
              return capability_data['MappedTerm'].includes(keyword['ToolTerm']);
            });
            if(found_keyword) {
              capability_data['tools_services'].push(Vue._.find(tools_services['umm-t'], function(item) {
                return item['concept-id'] == ummt['meta']['concept-id'];
              }));
            }
          });
        }
          capability_data['count'] = 0;
      }
      //console.log(capabilities_data);
      this.UPDATE_CAPABILITIES(capabilities_data);
    }
  },
  created: function() {
    let self = this;
    let drupal_cloud_datasets_data = Drupal && Drupal.cloud_datasets;
    //let drupal_cloud_datasets_data = drupalSettings && drupalSettings.cloud_datasets;
    
    if(!drupal_cloud_datasets_data) {
      Vue.axios.get('json/cloud-data.json').then(function(response) {
        //console.log(response.data);
        //let total_pages = response.data.datasets_parameters.size/response.data.datasets_parameters.page_size;
        let query_options = {'headers': {}}
        let hits = response.data.datasets_parameters.size, total_pages = 1;
        Vue.axios.post(response.data.faceted_search_url).then(function(faceted_search_response) {
          // console.log(response.data.faceted_search_url);
          // console.log(hits);
          hits = faceted_search_response.data.hits;
          total_pages = Math.ceil(hits/response.data.datasets_parameters.page_size);
          self.SET_APPEND_DATASETS(faceted_search_response.data.items);
          return {'total_pages': total_pages};
        }).then(function(query_response) {
          console.log(query_response);
          Vue._.range(2, query_response['total_pages']+1).forEach((current, index, range) => {
            Vue.axios.post(response.data.faceted_search_url+"&page_num="+current).then(function(faceted_search_response) {
              //console.log(faceted_search_response)
              self.SET_APPEND_DATASETS(faceted_search_response.data.items);
            });
          });          
        });      

        Vue.axios.get('json/umm-tools-services-capabilities.json').then(function(response) {
          self.set_umms_capabilities(response.data.umm_data.umm_s, response.data.umm_data.umm_t, response.data.tools_services, response.data.capabilities);
        });             
        
        self.SET_DATA(response.data);
        self.SET_DATA_READY(true);
      });
      Vue.axios.get('json/umm-tools-services-capabilities.json').then(function(response) {
        self.set_umms_capabilities(response.data.umm_data.umm_s, response.data.umm_data.umm_t, response.data.tools_services, response.data.capabilities);
      });      
    } else {      
      self.SET_DATA(drupal_cloud_datasets_data);      
      if(drupal_cloud_datasets_data.umm_tools_services_capabilities_api) {
        Vue.axios.get(drupal_cloud_datasets_data.base_path + drupal_cloud_datasets_data.umm_tools_services_capabilities_api).then(function(response) {
          self.set_umms_capabilities(response.data.umm_data.umm_s, response.data.umm_data.umm_t, response.data.tools_services, response.data.capabilities);
        }).catch(errors => {
          console.log(errors);
        });
      } else if(drupal_cloud_datasets_data.umm_data) {
        self.set_umms_capabilities(drupal_cloud_datasets_data.umm_data.umm_s, drupal_cloud_datasets_data.umm_data.umm_t, drupal_cloud_datasets_data.tools_services, drupal_cloud_datasets_data.capabilities);
      } else {
        self.load_capabilities_services_tools(drupal_cloud_datasets_data.capabilities,drupal_cloud_datasets_data.tools_services,drupal_cloud_datasets_data.umm_s_api,drupal_cloud_datasets_data.umm_t_api);
      }
      
      if(!drupal_cloud_datasets_data.data && !drupal_cloud_datasets_data.data_api) {
        let start_page_index = 1;
        if(drupal_cloud_datasets_data.paging_data)  {          
          if(drupal_cloud_datasets_data.datasets_parameters.page_total <= start_page_index) {
            self.SET_DATA_READY(true);
          } else {
            start_page_index = 2;
            self.retrieve_paging_datasets(drupal_cloud_datasets_data.api, start_page_index);
          }
        } else {
          self.retrieve_paging_datasets(drupal_cloud_datasets_data.api, start_page_index);
        }
      } else if(drupal_cloud_datasets_data.data_api) {
        Vue.axios.get(drupal_cloud_datasets_data.base_path + drupal_cloud_datasets_data.data_api).then(function(response) {
          self.SET_DATASETS(response.data.items);
          self.SET_DATA_READY(true);
        }).catch(errors => {
          console.log(errors);
        });
      } else {
        self.SET_DATA_READY(true);
      }
    }
  }
}
</script>